// import { checkValidAddress } from '../utils/checkValidAddress';

/**
 * Represents an ERC20 token with a unique address and some metadata.
 */
export class Token {
	/**
	 * The chain ID on which this currency resides
	 */
	readonly chainId: number;
	/**
	 * The decimals used in representing currency amounts
	 */
	readonly decimals: number;
	/**
	 * The name of the currency, i.e. a descriptive textual non-unique identifier
	 */
	readonly name: string;
	/**
	 * The symbol of the currency, i.e. a short textual non-unique identifier
	 */
	readonly symbol?: string;
	/**
	 * The contract address on the chain on which this token lives
	 */
	readonly address: string;

	// * @param bypassChecksum If true it only checks for length === 42, startsWith 0x and contains only hex characters
	/**
	 *
	 * @param chainId {@link BaseCurrency#chainId}
	 * @param address The contract address on the chain on which this token lives
	 * @param decimals {@link BaseCurrency#decimals}
	 * @param name {@link BaseCurrency#name}
	 * @param symbol {@link BaseCurrency#symbol}
	 */
	constructor(chainId: number, address: string, decimals: number, name: string, symbol?: string){
        if (!Number.isSafeInteger(chainId)) throw new Error();
        if (!(decimals >= 0 && decimals < 255 && Number.isInteger(decimals))) throw new Error();

        this.chainId = chainId;
        this.decimals = decimals;
        this.name = name;
        this.symbol = symbol;
		this.address = address.toLocaleLowerCase();
	}

	
	/**
	 * Returns true if the address of this token sorts before the address of the other token
	 * @param other other token to compare
	 * @throws if the tokens have the same address
	 * @throws if the tokens are on different chains
	 */
	public sortsBefore(other: Token): boolean {
		if (this.chainId !== other.chainId){
			throw new Error();
		}
		if (this.address.toLowerCase() === other.address.toLowerCase()){
			throw new Error();
		}
		return this.address.toLowerCase() < other.address.toLowerCase()
	}

	/**
	 * Return this token, which does not need to be wrapped
	 */
	public get wrapped(): Token {
		return this;
	}
}